(() => {
  const legacyPanel = /size chart|printed\s*&\s*shipped|try then decide guarantee|benefit call out|^product info$/i;
  const legacyPanelFile = /size[_-]?chart|printed[_-]?shipped|try[_-]?then[_-]?decide[_-]?guarantee|benefit[_-]?call[_-]?out|hollow[_-]?product[_-]?images/i;
  const modelPhoto = /modeled lifestyle|generated model photo/i;
  const photoAlt = (slide) => slide.querySelector('img.image-magnify-none')?.alt || slide.querySelector('.product__modal-opener img')?.alt || '';
  const photoSrc = (slide) => slide.querySelector('img.image-magnify-none')?.currentSrc || slide.querySelector('img.image-magnify-none')?.src || '';

  function arrange(gallery, selectedColor) {
    if (!gallery?.querySelector('.bb-editorial-slide')) return;
    const viewer = gallery.querySelector('.product__media-list');
    const thumbs = gallery.querySelector('.thumbnail-list');
    if (!viewer) return;

    for (const slide of [...viewer.querySelectorAll(':scope > li[data-media-id]')]) {
      if (slide.classList.contains('bb-editorial-slide')) continue;
      const alt = photoAlt(slide);
      if (!legacyPanel.test(alt) && !legacyPanelFile.test(photoSrc(slide))) continue;
      thumbs?.querySelector(`[data-target="${slide.dataset.mediaId}"]`)?.remove();
      slide.remove();
    }

    const slides = [...viewer.querySelectorAll(':scope > li[data-media-id]')];
    const photos = slides.filter((slide) => !slide.classList.contains('bb-editorial-slide'));
    const primary = photos.find((slide) => slide.classList.contains('is-active')) || photos[0];
    const color = (selectedColor || '').toLowerCase();
    const matchingModel = photos.find((slide) => slide !== primary && modelPhoto.test(photoAlt(slide)) && (!color || photoAlt(slide).toLowerCase().includes(color)));
    const otherModels = photos.filter((slide) => slide !== primary && slide !== matchingModel && modelPhoto.test(photoAlt(slide)));
    for (const slide of photos) {
      const hide = otherModels.includes(slide);
      slide.classList.toggle('bb-gallery-color-hidden', hide);
      const thumb = thumbs?.querySelector(`[data-target="${slide.dataset.mediaId}"]`);
      thumb?.classList.toggle('bb-gallery-color-hidden', hide);
    }
    const byRole = (role) => viewer.querySelector(`[data-bb-role="${role}"]`);
    const ordered = [primary, matchingModel, ...photos.filter((slide) => slide !== primary && slide !== matchingModel && !otherModels.includes(slide)), byRole('size'), byRole('community'), byRole('why'), byRole('origin'), byRole('guarantee'), ...otherModels].filter(Boolean);

    for (const slide of ordered) {
      viewer.appendChild(slide);
      const thumb = thumbs?.querySelector(`[data-target="${slide.dataset.mediaId}"]`);
      if (thumb) thumbs.appendChild(thumb);
    }
    if (thumbs) [...thumbs.querySelectorAll('[data-target]')].filter((thumb) => thumb.getClientRects().length).forEach((thumb, index) => { thumb.dataset.mediaPosition = String(index + 1); });
    gallery.querySelector('[id^="GalleryViewer"]')?.resetPages?.();
    gallery.querySelector('[id^="GalleryThumbnails"]')?.resetPages?.();
    const total = gallery.querySelector('.slider-counter--total');
    if (total) {
      gallery.bbEditorialSlideCount = thumbs
        ? [...thumbs.querySelectorAll('[data-target]')].filter((thumb) => thumb.getClientRects().length).length
        : ordered.filter((slide) => !slide.classList.contains('bb-gallery-color-hidden')).length;
      total.textContent = String(gallery.bbEditorialSlideCount);
      if (!gallery.bbTotalObserver) {
        gallery.bbTotalObserver = new MutationObserver(() => {
          const expected = String(gallery.bbEditorialSlideCount);
          if (total.textContent !== expected) total.textContent = expected;
        });
        gallery.bbTotalObserver.observe(total, { childList: true, characterData: true, subtree: true });
      }
    }
  }

  window.bbArrangeProductGallery = arrange;
  document.addEventListener('DOMContentLoaded', () => {
    const color = document.querySelector('variant-radios input[name="Color"]:checked')?.value || '';
    document.querySelectorAll('media-gallery').forEach((gallery) => arrange(gallery, color));
  });
})();
